const RAIN_STREAKS = [
  { x: 4, y: -8, len: 14, delay: 0, dur: 0.7, opacity: 0.55 },
  { x: 12, y: -18, len: 22, delay: 0.15, dur: 0.85, opacity: 0.35 },
  { x: 20, y: -6, len: 11, delay: 0.35, dur: 0.65, opacity: 0.45 },
  { x: 28, y: -22, len: 26, delay: 0.05, dur: 0.95, opacity: 0.3 },
  { x: 36, y: -10, len: 16, delay: 0.45, dur: 0.75, opacity: 0.5 },
  { x: 44, y: -16, len: 20, delay: 0.25, dur: 0.8, opacity: 0.28 },
  { x: 52, y: -4, len: 12, delay: 0.55, dur: 0.6, opacity: 0.48 },
  { x: 60, y: -20, len: 24, delay: 0.1, dur: 0.9, opacity: 0.32 },
  { x: 68, y: -12, len: 15, delay: 0.4, dur: 0.72, opacity: 0.42 },
  { x: 76, y: -24, len: 28, delay: 0.2, dur: 1.0, opacity: 0.25 },
  { x: 84, y: -8, len: 13, delay: 0.5, dur: 0.68, opacity: 0.5 },
  { x: 92, y: -14, len: 18, delay: 0.3, dur: 0.78, opacity: 0.34 },
  { x: 8, y: -28, len: 10, delay: 0.6, dur: 0.7, opacity: 0.22 },
  { x: 48, y: -30, len: 17, delay: 0.7, dur: 0.88, opacity: 0.3 },
  { x: 72, y: -26, len: 21, delay: 0.18, dur: 0.82, opacity: 0.38 },
];

export default function AmbianceRainAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--rainy"
      aria-hidden="true"
    >
      <svg
        className="mode-tile__rain-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {RAIN_STREAKS.map((streak, index) => (
          <line
            key={index}
            className="mode-tile__rain-streak"
            x1={streak.x}
            y1={streak.y}
            x2={streak.x + streak.len * 0.35}
            y2={streak.y + streak.len}
            style={{
              opacity: streak.opacity,
              animationDelay: `${streak.delay}s`,
              animationDuration: `${streak.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
